import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class StatementService {
    constructor(private http: HttpClient) {
    }

    createStatement(payment, oldPlanTypeId): any {
        debugger
        console.log(JSON.stringify(payment))
        return this.http.post(Configuration.apiUrl + 'api/Statement/createStatement', JSON.stringify(payment), {
            headers: new HttpHeaders().set('Content-Type', 'application/json')
        })
    }

    adminCreateStatement(storeName, month, year, price, paid, generateIugu): any {
        console.log(Configuration.apiUrl + 'api/statement/AdminCreateStatement?month=' + month + '&year=' + year + '&seoName=' + storeName + '&price=' + price + '&paid=' + paid + '&generateIugu=' + generateIugu);
        return this.http.get(Configuration.apiUrl + 'api/statement/AdminCreateStatement?month=' + month + '&year=' + year + '&seoName=' + storeName + '&price=' + price + '&paid=' + paid + '&generateIugu=' + generateIugu)
    }
}